"use client";

import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import { useFullScreen } from "./contexts/FullScreenProvider";

import { usePowerSearch } from "./contexts/power-search-context";
import SearchInputGroup from "./SearchInputGroup";
import SearchFilters from "./SearchFilters";
import SearchResults from "./SearchResults";
import FullPageLoadingIcon from "./FullPageLoadingIcon"; // Placeholder

const SearchContainer = () => {
  const {
    handleSearchSubmit,
    clearAllFilters,
    filterOptionsLoading,
    searchResultsLoading,
    showResults,
    currentView,
  } = usePowerSearch();

  const onFormSubmit = (event) => {
    event.preventDefault();
    handleSearchSubmit(true); // true indicates it's a new form submission
  };

  if (filterOptionsLoading && !showResults) {
    return <FullPageLoadingIcon />;
  }

  return (
    <div>
      <Form noValidate onSubmit={onFormSubmit} className="power-search-modern">
        <Row style={{ margin: 0 }} className="g-6">
          {/* Filters/Search Section */}
          <Col lg={3} md={3} style={{ padding: 0 }}>
            <Card
              className="mb-4"
              style={{
                borderRight: "1px solid #dee2e6",
                borderTopRightRadius: "0",
                borderBottomRightRadius: "0",
              }}
            >
              <Card.Body className="">
                {/* Keyword Search */}
                <div className="mb-3">
                  <SearchInputGroup />
                </div>
                {/* Filters */}

                <SearchFilters />
              </Card.Body>
            </Card>
          </Col>

          {/* Results Section */}
          <Col md={9} lg={9} style={{ padding: 0 }}>
            <SearchResults currentView={currentView} />
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default SearchContainer;
